import { createContext, useContext, useEffect, useState } from "react";
import { useQuantityDefinition } from "../quantity-definition-provider/quantity-definition-provider";

const GoldTradingPlatformLoadingContext = createContext(null);

const GoldTradingPlatformLoadingProvider = ({children}) => {
    const {quantityDefinitions} = useQuantityDefinition();
    
    const [isLoaded,  setIsLoaded] = useState(false);
    const [allLoaded, setAllLoaded] = useState(null)

    useEffect(() => {
        initializeAllLoaded();
    }, [
        quantityDefinitions?.length
    ])

    const initializeAllLoaded = () => {
        const initial_object = {}
        if(quantityDefinitions?.length > 0){
            for(const qd of quantityDefinitions){
                initial_object[qd['code']] = {
                    'sellLoaded': false,
                    'buyLoaded': false,
                    'stepLoaded': false,
                    'qdLoaded': false,
                    'qdSellLoaded': false,
                    'qdBuyLoaded': false,
                }
            }
            setAllLoaded(initial_object);
        }
    }

    const changeAllLoaded = (qdCode, qdKey, qdValue) => {
        const tempAllLoaded = allLoaded;
        let tempIsLoaded = true;
        if(tempAllLoaded !== null && tempAllLoaded[qdCode])
            tempAllLoaded[qdCode][qdKey] = qdValue;
        setAllLoaded(tempAllLoaded);
        if (tempAllLoaded !== null && quantityDefinitions?.length > 0){
            for(const qd of quantityDefinitions){
                if(tempAllLoaded[qd['code']]['sellLoaded'] === false){
                    tempIsLoaded = false;
                }
                else if(tempAllLoaded[qd['code']]['buyLoaded'] === false){
                    tempIsLoaded = false;
                }
                else if(tempAllLoaded[qd['code']]['stepLoaded'] === false){
                    tempIsLoaded = false;
                }
                else if(tempAllLoaded[qd['code']]['qdLoaded'] === false){
                    tempIsLoaded = false;
                }
                else if(tempAllLoaded[qd['code']]['qdSellLoaded'] === false){
                    tempIsLoaded = false;
                }
                else if(tempAllLoaded[qd['code']]['qdBuyLoaded'] === false){
                    tempIsLoaded = false;
                }
            }
        } else {
            tempIsLoaded = false;
        }
        setIsLoaded(tempIsLoaded);
    }

    return (
        <GoldTradingPlatformLoadingContext.Provider
            value={{
                isLoaded,
                changeAllLoaded,
            }}
        >
            {children}
        </GoldTradingPlatformLoadingContext.Provider>
    );
}

export default GoldTradingPlatformLoadingProvider;

export const useGoldTradingPatformLoading = () => {
    return useContext(GoldTradingPlatformLoadingContext);
}